const days = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

type ScheduleDay = {
  timeframes: { from: string; to: string }[];
};

type ScheduleTableProps = {
  schedule?: Record<string, ScheduleDay>;
};

export function ScheduleTable({ schedule }: ScheduleTableProps) {
  if (!schedule) return null;

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-[600px] w-full text-center text-xs sm:text-sm md:text-base">
        <thead>
          <tr className="h-14 sm:h-16 md:h-20">
            <th className="w-16 sm:w-20"></th>
            {days.map((day) => (
              <th
                key={day}
                className="font-semibold bg-dove-gray-lightest px-3"
              >
                {day}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr className="border-t-2 border-neutral-darkest/30">
            <td className="font-semibold text-left pl-2 sm:pl-4 py-3 sm:py-4 md:py-6">
              Zeitraum
            </td>
            {days.map((day) => {
              const timeframes = schedule[day]?.timeframes ?? [];

              return (
                <td key={day} className="py-3 sm:py-4 md:py-6">
                  {timeframes.length === 0 ? (
                    <span>-</span>
                  ) : (
                    <div className="flex flex-col gap-1">
                      {timeframes.map((tf, i) => (
                        <span key={i} className="whitespace-nowrap">
                          {tf.from} – {tf.to === "-1:00" ? "unbegrenzt" : tf.to}
                        </span>
                      ))}
                    </div>
                  )}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
